"use client";
import { jsx as o } from "react/jsx-runtime";
import { ReactSVG as e } from "react-svg";
import { ikp as r } from "../../components/factory.js";
import { iconMap as u } from "./built-in-icons.js";
import { memo as c } from "react";
const m = r("svg", {
  _id: "icon",
  // viewBox: '0 0 24 24',
  role: "presentation",
  "aria-hidden": !0,
  focusable: !1,
  "data-type": "built-in"
}), s = r(e, {
  _id: "icon",
  "data-type": "custom"
}), l = r("img", {
  _id: "icon",
  "data-type": "custom"
}), v = c(
  ({ iconSettings: t, ...n }) => {
    if (!t)
      return /* @__PURE__ */ o(
        "div",
        {
          style: {
            width: "1em",
            minHeight: "1em"
          }
        }
      );
    if ("builtIn" in t) {
      const i = u[t.builtIn];
      return i ? /* @__PURE__ */ o(m, { ...n, asChild: !0, children: /* @__PURE__ */ o(i, {}) }) : null;
    }
    if ("custom" in t) {
      const i = t.custom;
      return i.toLowerCase().endsWith(".svg") ? /* @__PURE__ */ o(s, { src: i, wrapper: "div", ...n }) : /* @__PURE__ */ o(l, { src: t.custom, alt: "custom icon", ...n });
    }
    return null;
  },
  (t, n) => a(t.iconSettings, n.iconSettings)
);
function a(t, n) {
  return "builtIn" in t && "builtIn" in n ? t.builtIn === n.builtIn : "custom" in t && "custom" in n ? t.custom === n.custom : !1;
}
export {
  v as BuiltInIconRenderer
};
